// tracker.js

let ws = null;

/** Привязать WebSocket */
export function setTrackerWS(socket) {
  ws = socket;
}

/** Отправить событие (только через WS, если не подключён — событие не отправляется) */
export function track(event, data) {
  if (ws && ws.readyState === WebSocket.OPEN) {
    ws.send(JSON.stringify({ type: 'track', event, data }));
  }
}
